import Vue from 'vue'
import App from './App.vue'
import VueTheMask from 'vue-the-mask'
import VueObserveVisibility from 'vue-observe-visibility'
import { toast } from './toast'

Vue.use(VueObserveVisibility)
Vue.use(VueTheMask)

Vue.config.productionTip = false

// Ошибки не должны падать молча: логируем и показываем пользователю нейтральный тост.
Vue.config.errorHandler = (err, vm, info) => {
  console.error('[Vue error]', info, err)
}

window.addEventListener('unhandledrejection', (event) => {
  console.error('[unhandledrejection]', event.reason)
  toast('Произошла ошибка. Попробуйте обновить страницу.', 'error')
})

new Vue({ render: render => render(App) })
    .$mount('#app')

// Push-уведомления (Firebase) намеренно не инициализируются в этой версии:
// service worker и VAPID-ключ не настроены. Реализация — отдельной задачей.
